module.exports = __webpack_public_path__ + "img/logo-white.603c5dbe.png";